import styled, { css, keyframes, createGlobalStyle, withTheme, ThemeProvider as BaseThemeProvider, ThemeContext as StyledThemeContext } from 'styled-components';
var ThemeContext = StyledThemeContext;
export { css, createGlobalStyle, keyframes, BaseThemeProvider, ThemeContext, withTheme };
export default styled;
//# sourceMappingURL=index.js.map